import { Suspense, useEffect } from "react";
import { I18nextProvider } from "react-i18next";
import { Route, Switch, useHistory } from "react-router-dom";
import PrivateRoute from "./components/PrivateRoute";
import Dashboard from "./pages/Dashboard";
import SignUp from "./pages/SignUp";
import i18n from "./i18n";
import SalaVideoConferencia from "./pages/SalaVideoConferencia";
import Home from "./pages/Home";
import AgendamientoCuenta from "./pages/AgendamientoCuenta";
import GetLogoSistema from "./utils/getLogoSistema";
import ModificarCita from "./pages/publico/ModificarCita";
import CheckTokenConferencia from "./pages/publico/CheckTokenConferencia";
import CitaMensaje from "./pages/CitaMensaje";
import AutoagendamientoV2 from "./pages/autoagendamiento/AutoagendamientoV2";
import MexConferencia from "./pages/videoconferenciav2/MexConferencia";
import ClbConferencia from "./pages/videoconferenciav2/ClbConferencia";
import AgendamientoCuentaV2 from "./pages/AgendamientoCuentaV2";
import Autoagendamiento from "./pages/Autoagendamiento";

function App() {
  const history = useHistory();

  useEffect(() => {
    let urlSearch = window.location.search;
    let urlPath = window.location.pathname;
    let path = `${urlPath}${urlSearch}`;

    if (
      path ===
      "/amv/24a53A10eac0483fA2b921d1c95ebf65/?partner=a67fa756441c4228a198d1aaa1230057&specialty=19b122d9754d4bd4a4914abe3a8085cb&copay=4818ad88"
    ) {
      history.replace("/public/videoconferencia/54/6");
    } else if (
      path ===
      "/amv/24a53A10eac0483fA2b921d1c95ebf65/?partner=a67fa756441c4228a198d1aaa1230057&specialty=0a7fb20cbf0e4852be17a796b2e95582&copay=4818ad88"
    ) {
      history.replace("/public/videoconferencia/67/6");
    } else if (
      path ===
      "/amv/24a53A10eac0483fA2b921d1c95ebf65/?partner=a67fa756441c4228a198d1aaa1230057&specialty=aef94b9855824f15a86c7b113cdc0b60&copay=4818ad88"
    ) {
      history.replace("/public/videoconferencia/59/6");
    } else if (
      path ===
      "/amv/24a53A10eac0483fA2b921d1c95ebf65/?partner=a67fa756441c4228a198d1aaa1230057&specialty=160337a595574469a2ef9916ca5c0ff1&copay=4818ad88"
    ) {
      history.replace("/public/videoconferencia/142/6");
    } else if (
      path ===
      "/amv/24a53A10eac0483fA2b921d1c95ebf65/?partner=a67fa756441c4228a198d1aaa1230057&specialty=19b122d9754d4bd4a4914abe3a8085cb&copay=ae09477a"
    ) {
      history.replace("/public/videoconferencia/54/7");
    } else if (
      path ===
      "/amv/24a53A10eac0483fA2b921d1c95ebf65/?partner=a67fa756441c4228a198d1aaa1230057&specialty=0a7fb20cbf0e4852be17a796b2e95582&copay=ae09477a"
    ) {
      history.replace("/public/videoconferencia/67/7");
    } else if (
      path ===
      "/amv/24a53A10eac0483fA2b921d1c95ebf65/?partner=a67fa756441c4228a198d1aaa1230057&specialty=aef94b9855824f15a86c7b113cdc0b60&copay=ae09477a"
    ) {
      history.replace("/public/videoconferencia/59/7");
    } else if (
      path ===
      "/amv/24a53A10eac0483fA2b921d1c95ebf65/?partner=a67fa756441c4228a198d1aaa1230057&specialty=160337a595574469a2ef9916ca5c0ff1&copay=ae09477a"
    ) {
      history.replace("/public/videoconferencia/142/7");
    } else if (
      path ===
        "/amv/24a53A10eac0483fA2b921d1c95ebf65/?partner=a67fa756441c4228a198d1aaa1230057" ||
      path ===
        "/amv/24a53A10eac0483fA2b921d1c95ebf65/?partner=a67fa756441c4228a198d1aaa1230057&copay=4d98z9c2"
    ) {
      history.replace("/public/videoconferencia/54/8");
    } else if (
      path ===
        "/amv/24a53A10eac0483fA2b921d1c95ebf65/?partner=a67fa756441c4228a198d1aaa1230057&specialty=0a7fb20cbf0e4852be17a796b2e95582" ||
      path ===
        "/amv/24a53A10eac0483fA2b921d1c95ebf65/?partner=a67fa756441c4228a198d1aaa1230057&specialty=0a7fb20cbf0e4852be17a796b2e95582&copay=4d98z9c2"
    ) {
      history.replace("/public/videoconferencia/67/8");
    } else if (
      path ===
      "/amv/24a53A10eac0483fA2b921d1c95ebf65/?partner=a67fa756441c4228a198d1aaa1230057&copay=7c9defc3"
    ) {
      history.replace("/public/videoconferencia/54/9");
    } else if (
      path ===
      "/amv/24a53A10eac0483fA2b921d1c95ebf65/?partner=a67fa756441c4228a198d1aaa1230057&specialty=aef94b9855824f15a86c7b113cdc0b60&copay=7c9defc3"
    ) {
      history.replace("/public/videoconferencia/59/9");
    } else if (
      path ===
      "/amv/24a53A10eac0483fA2b921d1c95ebf65/?partner=a67fa756441c4228a198d1aaa1230057&specialty=0a7fb20cbf0e4852be17a796b2e95582&copay=7c9defc3"
    ) {
      history.replace("/public/videoconferencia/67/9");
    } else if (
      path ===
      "/amv/24a53A10eac0483fA2b921d1c95ebf65/?partner=a67fa756441c4228a198d1aaa1230057&copay=bf9a4dc1"
    ) {
      history.replace("/public/videoconferencia/54/10");
    } else if (
      path ===
      "/amv/24a53A10eac0483fA2b921d1c95ebf65/?partner=a67fa756441c4228a198d1aaa1230057&specialty=aef94b9855824f15a86c7b113cdc0b60&copay=bf9a4dc1"
    ) {
      history.replace("/public/videoconferencia/59/10");
    } else if (
      path ===
      "/amv/24a53A10eac0483fA2b921d1c95ebf65/?partner=a67fa756441c4228a198d1aaa1230057&specialty=0a7fb20cbf0e4852be17a796b2e95582&copay=bf9a4dc1"
    ) {
      history.replace("/public/videoconferencia/67/10");
    } else if (
      path ===
      "/amv/24a53A10eac0483fA2b921d1c95ebf65/?partner=a67fa756441c4228a198d1aaa1230057&copay=e1a9d4d9"
    ) {
      history.replace("/public/videoconferencia/54/11");
    } else if (
      path ===
      "/amv/24a53A10eac0483fA2b921d1c95ebf65/?partner=a67fa756441c4228a198d1aaa1230057&specialty=aef94b9855824f15a86c7b113cdc0b60&copay=e1a9d4d9"
    ) {
      history.replace("/public/videoconferencia/59/11");
    } else if (
      path ===
      "/amv/24a53A10eac0483fA2b921d1c95ebf65/?partner=a67fa756441c4228a198d1aaa1230057&specialty=0a7fb20cbf0e4852be17a796b2e95582&copay=e1a9d4d9"
    ) {
      history.replace("/public/videoconferencia/67/11");
    } else if (
      path ===
      "/amv/24a53A10eac0483fA2b921d1c95ebf65/?partner=a67fa756441c4228a198d1aaa1230057&specialty=160337a595574469a2ef9916ca5c0ff1&copay=e1a9d4d9"
    ) {
      history.replace("/public/videoconferencia/142/11");
    } else if (
      path ===
      "/amv/24a53A10eac0483fA2b921d1c95ebf65/?partner=a67fa756441c4228a198d1aaa1230057"
    ) {
      history.replace("/public/videoconferencia/54/12");
    } else if (
      path ===
      "/amv/24a53A10eac0483fA2b921d1c95ebf65/?partner=a67fa756441c4228a198d1aaa1230057&specialty=aef94b9855824f15a86c7b113cdc0b60"
    ) {
      history.replace("/public/videoconferencia/59/12");
    } else if (
      path ===
      "/amv/24a53A10eac0483fA2b921d1c95ebf65/?partner=a67fa756441c4228a198d1aaa1230057&specialty=0a7fb20cbf0e4852be17a796b2e95582"
    ) {
      history.replace("/public/videoconferencia/67/12");
    } else if (
      path ===
      "/amv/24a53A10eac0483fA2b921d1c95ebf65/?partner=a67fa756441c4228a198d1aaa1230057&specialty=7347e52e17c84a8eb17b6e8cf9e653e0"
    ) {
      history.replace("/public/videoconferencia/140/12");
    } else if (
      path ===
      "/amv/24a53A10eac0483fA2b921d1c95ebf65/?partner=a67fa756441c4228a198d1aaa1230057&copay= a5d7b162"
    ) {
      history.replace("/public/videoconferencia/54/13");
    } else if (
      path ===
      "/amv/24a53A10eac0483fA2b921d1c95ebf65/?partner=a67fa756441c4228a198d1aaa1230057&specialty=19b122d9754d4bd4a4914abe3a8085cb&copay=RHW"
    ) {
      history.replace("/public/videoconferencia/54/14");
    } else if (
      path ===
      "/amv/24a53A10eac0483fA2b921d1c95ebf65/?partner=a67fa756441c4228a198d1aaa1230057&specialty=0a7fb20cbf0e4852be17a796b2e95582&copay=RHW"
    ) {
      history.replace("/public/videoconferencia/67/14");
    } else if (
      path ===
      "/amv/24a53A10eac0483fA2b921d1c95ebf65/?partner=a67fa756441c4228a198d1aaa1230057&specialty=aef94b9855824f15a86c7b113cdc0b60&copay=RHW"
    ) {
      history.replace("/public/videoconferencia/59/14");
    } else if (
      path ===
      "/amv/24a53A10eac0483fA2b921d1c95ebf65/?partner=a67fa756441c4228a198d1aaa1230057&specialty=160337a595574469a2ef9916ca5c0ff1&copay=RHW"
    ) {
      history.replace("/public/videoconferencia/142/14");
    } else if (
      path ===
      "/amv/24a53A10eac0483fA2b921d1c95ebf65/?partner=a67fa756441c4228a198d1aaa1230057&specialty=19b122d9754d4bd4a4914abe3a8085cb&copay=TQIN"
    ) {
      history.replace("/public/videoconferencia/54/15");
    } else if (
      path ===
      "/amv/24a53A10eac0483fA2b921d1c95ebf65/?partner=a67fa756441c4228a198d1aaa1230057&specialty=0a7fb20cbf0e4852be17a796b2e95582&copay=TQIN"
    ) {
      history.replace("/public/videoconferencia/67/15");
    } else if (
      path ===
      "/amv/24a53A10eac0483fA2b921d1c95ebf65/?partner=a67fa756441c4228a198d1aaa1230057&specialty=aef94b9855824f15a86c7b113cdc0b60&copay=TQIN"
    ) {
      history.replace("/public/videoconferencia/59/15");
    } else if (
      path ===
      "/amv/24a53A10eac0483fA2b921d1c95ebf65/?partner=a67fa756441c4228a198d1aaa1230057&specialty=19b122d9754d4bd4a4914abe3a8085cb&copay=TQFAM"
    ) {
      history.replace("/public/videoconferencia/54/16");
    } else if (
      path ===
      "/amv/24a53A10eac0483fA2b921d1c95ebf65/?partner=a67fa756441c4228a198d1aaa1230057&specialty=0a7fb20cbf0e4852be17a796b2e95582&copay=TQFAM"
    ) {
      history.replace("/public/videoconferencia/67/16");
    } else if (
      path ===
      "/amv/24a53A10eac0483fA2b921d1c95ebf65/?partner=a67fa756441c4228a198d1aaa1230057&specialty=aef94b9855824f15a86c7b113cdc0b60&copay=TQFAM"
    ) {
      history.replace("/public/videoconferencia/59/16");
    } else if (
      path ===
      "/amv/24a53A10eac0483fA2b921d1c95ebf65/?partner=a67fa756441c4228a198d1aaa1230057&specialty=19b122d9754d4bd4a4914abe3a8085cb&copay=e579b6f0"
    ) {
      history.replace("/public/videoconferencia/54/17");
    } else if (
      path ===
      "/amv/24a53A10eac0483fA2b921d1c95ebf65/?partner=a67fa756441c4228a198d1aaa1230057&specialty=0a7fb20cbf0e4852be17a796b2e95582&copay=e579b6f0"
    ) {
      history.replace("/public/videoconferencia/67/17");
    } else if (
      path ===
      "/amv/24a53A10eac0483fA2b921d1c95ebf65/?partner=a67fa756441c4228a198d1aaa1230057&specialty=aef94b9855824f15a86c7b113cdc0b60&copay=e579b6f0"
    ) {
      history.replace("/public/videoconferencia/59/17");
    } else if (
      path ===
      "/amv/24a53A10eac0483fA2b921d1c95ebf65/?partner=a67fa756441c4228a198d1aaa1230057&specialty=19b122d9754d4bd4a4914abe3a8085cb&copay=990273c4"
    ) {
      history.replace("/public/videoconferencia/54/18");
    } else if (
      path ===
      "/amv/24a53A10eac0483fA2b921d1c95ebf65/?partner=a67fa756441c4228a198d1aaa1230057&specialty=0a7fb20cbf0e4852be17a796b2e95582&copay=990273c4"
    ) {
      history.replace("/public/videoconferencia/67/18");
    } else if (
      path ===
      "/amv/24a53A10eac0483fA2b921d1c95ebf65/?partner=a67fa756441c4228a198d1aaa1230057&specialty=aef94b9855824f15a86c7b113cdc0b60&copay=990273c4"
    ) {
      history.replace("/public/videoconferencia/59/18");
    }
  }, []);

  //para cambiar el favico
  const favicon = GetLogoSistema("favicon");
  useEffect(() => {
    const fav = document.getElementById("favicon");
    if (favicon !== undefined) {
      fav.href = favicon;
    }
  }, [favicon]);

  return (
    <Switch>
      <Suspense fallback="loading">
        <I18nextProvider i18n={i18n}>
          {/* url para video conferencia del cliente coporativo */}
          <Route
            path="/public/videoconferencia/:idSpeciality/:idAccount"
            component={SalaVideoConferencia}
          />

          <Route
            exact
            path="/public/link/:token"
            component={CheckTokenConferencia}
          />

          {/* <Route exact path="/public/conferencia/:id" component={VideoConferenciaClient} /> */}
          <Route
            exact
            path="/public/conferencia/:id"
            component={MexConferencia}
          ></Route>

          {/* <Route exact path="/public/conferencia/colombia/:id" component={VideoConferenciaColombiaClient} /> */}
          <Route
            exact
            path="/public/conferencia/colombia/:id"
            component={ClbConferencia}
          ></Route>

          <Route exact path="/public/autoagendamientoold/:id">
            <Autoagendamiento />
          </Route>
          <Route exact path="/public/autoagendamiento/:id">
            <AutoagendamientoV2 />
          </Route>

          <Route exact path="/public/agendamiento/cuenta/allianz/:idAccount">
            <AgendamientoCuenta />
          </Route>
          <Route exact path="/public/agendamiento/cuenta/:idAccount">
            <AgendamientoCuentaV2 />
          </Route>

          <Route exact path="/public/modificar/cita/colombia/:id">
            <ModificarCita />
          </Route>

          <Route exact path="/public/cita/mensaje">
            <CitaMensaje />
          </Route>

          <Route exact path="/">
            <Home />
          </Route>

          <Route path="/sign-up" component={SignUp} />
          <PrivateRoute path="/admin" component={Dashboard} />
        </I18nextProvider>
      </Suspense>
    </Switch>
  );
}

export default App;
